import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { auth, db } from '../firebase';
import {
  signInWithEmailAndPassword,
  signOut,
  updatePassword,
} from 'firebase/auth';
import { doc, getDoc, updateDoc, serverTimestamp } from 'firebase/firestore';

// Normaliza o perfil para UPPERCASE garantindo consistencia em todo o sistema.
// Aceita "Gestor", "gestor", "GESTOR", " gestor " => "GESTOR".
// Fallback: "OPERADOR" (perfil de menor risco entre os que tem acesso operacional).
function normalizarPerfil(raw) {
  const valor = (raw || '').toString().trim().toUpperCase();
  if (valor === 'GESTOR' || valor === 'OPERADOR' || valor === 'VISUALIZADOR') {
    return valor;
  }
  return 'OPERADOR';
}

export const useAuthStore = create(
  persist(
    (set, get) => ({
      usuario: null,
      perfil: null,
      precisaTrocarSenha: false,
      loading: false,

      login: async (email, senha) => {
        set({ loading: true });
        try {
          const cred = await signInWithEmailAndPassword(auth, email, senha);
          const snap = await getDoc(doc(db, 'usuarios', cred.user.uid));
          const dados = snap.exists() ? snap.data() : {};
          set({
            usuario: cred.user,
            perfil: normalizarPerfil(dados.perfil),
            precisaTrocarSenha: dados.precisaTrocarSenha === true,
            loading: false,
          });
        } catch (err) {
          set({ loading: false });
          throw err;
        }
      },

      logout: async () => {
        await signOut(auth);
        set({ usuario: null, perfil: null, precisaTrocarSenha: false });
      },

      // Troca a senha no Auth e marca precisaTrocarSenha = false
      trocarSenha: async (novaSenha) => {
        const { usuario } = get();
        if (!usuario) throw new Error('Sem sessão ativa.');
        if (!novaSenha || novaSenha.length < 6) {
          throw new Error('A senha deve ter ao menos 6 caracteres.');
        }
        // Troca no Firebase Auth (precisa de login recente; como acabou de logar, ok)
        await updatePassword(auth.currentUser, novaSenha);
        // Atualiza Firestore
        await updateDoc(doc(db, 'usuarios', usuario.uid), {
          precisaTrocarSenha: false,
          senhaTrocadaEm: serverTimestamp(),
          atualizadoEm: serverTimestamp(),
        });
        set({ precisaTrocarSenha: false });
      },
    }),
    { name: 'jatear-auth' }
  )
);